export const EDUCTION = [
	{
		id: "ED1",
		degree: "Front End Diploma",
		from: "Itrax Acedmy",
		date: "2021-2022",
		content: ["Content : Html Css Js Bootstrap JQuery ReactJs Sass Git Github"],
	},
	{
		id: "ED2",
		degree: "Bachelor of Commerce",
		from: "Helwan University",
		date: "2016-2020",
		content: [
			"department: Management information systems",
			"Grade: `Very good`",
		],
	},
];
